import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "ObeLogin" */ "./ObeLogin"),{
		fallback: <div>Loading...</div>
	})
};